// TODO | Remove once it will be moved to the RUIC
import { createIcon } from "@chakra-ui/react";

export const ScannerIcon = createIcon({
  displayName: "barcodeScannerIcon",
  viewBox: "0 0 40 40",
  path: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="4" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6667 14.5C13.6667 14.0417 14.0417 13.6667 14.5 13.6667H16.1667C16.625 13.6667 17 13.2917 17 12.8333C17 12.375 16.625 12 16.1667 12H13.6667C12.75 12 12 12.75 12 13.6667V16.1667C12 16.625 12.375 17 12.8333 17C13.2917 17 13.6667 16.625 13.6667 16.1667V14.5ZM12.8333 22C12.375 22 12 22.375 12 22.8333V25.3333C12 26.25 12.75 27 13.6667 27H16.1667C16.625 27 17 26.625 17 26.1667C17 25.7083 16.625 25.3333 16.1667 25.3333H14.5C14.0417 25.3333 13.6667 24.9583 13.6667 24.5V22.8333C13.6667 22.375 13.2917 22 12.8333 22ZM22.8333 12H25.3333C26.25 12 27 12.75 27 13.6667V16.1667C27 16.625 26.625 17 26.1667 17C25.7083 17 25.3333 16.625 25.3333 16.1667V14.5C25.3333 14.0417 24.9583 13.6667 24.5 13.6667H22.8333C22.375 13.6667 22 13.2917 22 12.8333C22 12.375 22.375 12 22.8333 12ZM25.3333 24.5C25.3333 24.9583 24.9583 25.3333 24.5 25.3333H22.8333C22.375 25.3333 22 25.7083 22 26.1667C22 26.625 22.375 27 22.8333 27H25.3333C26.25 27 27 26.25 27 25.3333V22.8333C27 22.375 26.625 22 26.1667 22C25.7083 22 25.3333 22.375 25.3333 22.8333V24.5ZM17 19.5C17 18.1167 18.1167 17 19.5 17C20.8833 17 22 18.1167 22 19.5C22 20.8833 20.8833 22 19.5 22C18.1167 22 17 20.8833 17 19.5Z"
        fill="#0D73FF"
      />
    </svg>
  ),
});

export const UploadIcon = createIcon({
  displayName: "Add a photo",
  viewBox: "0 0 40 40",
  path: (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="4" />
      <rect width="16" height="16" transform="translate(12 12)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7267 13.7266C21.4734 13.4733 21.1334 13.3333 20.7801 13.3333H16.0001C15.2667 13.3333 14.6667 13.9333 14.6667 14.6666V25.3333C14.6667 26.0666 15.2601 26.6666 15.9934 26.6666H24.0001C24.7334 26.6666 25.3334 26.0666 25.3334 25.3333V17.8866C25.3334 17.5333 25.1934 17.1933 24.9401 16.9466L21.7267 13.7266ZM22.0001 22.6666H20.6667V23.9999C20.6667 24.3666 20.3667 24.6666 20.0001 24.6666C19.6334 24.6666 19.3334 24.3666 19.3334 23.9999V22.6666H18.0001C17.6334 22.6666 17.3334 22.3666 17.3334 21.9999C17.3334 21.6333 17.6334 21.3333 18.0001 21.3333H19.3334V19.9999C19.3334 19.6333 19.6334 19.3333 20.0001 19.3333C20.3667 19.3333 20.6667 19.6333 20.6667 19.9999V21.3333H22.0001C22.3667 21.3333 22.6667 21.6333 22.6667 21.9999C22.6667 22.3666 22.3667 22.6666 22.0001 22.6666ZM20.6667 14.3333V17.3333C20.6667 17.6999 20.9667 17.9999 21.3334 17.9999H24.3334L20.6667 14.3333Z"
        fill="#0D73FF"
      />
    </svg>
  ),
});
